import axios from "axios";

export interface PrescriptionFormMasters {
  history: any[];
  examination: any[];
  procedures: any[];
  dosage: any[];
  routes: any[];
  frequency: any[];
  cases: any[];
}

export const emptyPrescriptionFormMasters = (): PrescriptionFormMasters => ({
  history: [],
  examination: [],
  procedures: [],
  dosage: [],
  routes: [],
  frequency: [],
  cases: [],
});

export const dedupeDosageByMedNotation = (items: any[] = []) =>
  Array.from(
    new Map(items.map((item) => [item?.med_notation, item])).values()
  ).filter(Boolean);

export async function fetchPrescriptionFormMasters(): Promise<PrescriptionFormMasters> {
  const response = await axios.get(
    `${process.env.REACT_APP_OPD_API_URL}/opd-master-data/prescription-form`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  if (response.data?.isSuccess === false) {
    throw new Error(response.data?.message || "Failed to load prescription masters");
  }

  const data = response.data?.data || {};
  return {
    history: data.history || [],
    examination: data.examination || [],
    procedures: data.procedures || [],
    dosage: dedupeDosageByMedNotation(data.dosage || []),
    routes: data.routes || [],
    frequency: data.frequency || [],
    cases: data.cases || [],
  };
}
